import { gql } from "@apollo/client";

export const COMPLIANCE_INVITE_FIELDS = gql`
  fragment ComplianceInviteFields on ComplianceRegistrationInviteToken {
    id
    tenDlcCampaignRegistrations {
      id
      brandRegistration {
        id
        organizationName
      }
      submittedAt
      submittedByUser {
        id
        fullName
      }
    }
    tollFreeRegistrations {
      id
      organizationName
      createdAt
    }
    proposedTenantSlug
    registrationType
    token
    createdAt
    createdByStaffEmail
    updatedAt
    deletedAt
  }
`;

export const LIST_COMPLIANCE_INVITES = gql`
  ${COMPLIANCE_INVITE_FIELDS}
  query listComplianceInvites {
    listComplianceInvites {
      ...ComplianceInviteFields
    }
  }
`;

export const CREATE_COMPLIANCE_INVITE = gql`
  ${COMPLIANCE_INVITE_FIELDS}
  mutation createComplianceInvite($input: CreateComplianceInviteInput!) {
    createComplianceInvite(input: $input) {
      ...ComplianceInviteFields
    }
  }
`;

export const DELETE_COMPLIANCE_INVITE = gql`
  mutation deleteComplianceInvite($input: DeleteComplianceInviteInput!) {
    deleteComplianceInvite(input: $input) {
      success
    }
  }
`;
